import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: ',', label: 'E' },
			{ value: ';', label: 'Ou' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

